import { useContext } from 'react';
import MainContext from '../Context';
import { isRevolvingCreditProduct } from '../helpers';
import isDCHSettlementEnrolled from '../helpers/isDCHSettlementEnrolled';
import useApiMachine from './machines/useApiMachine';
export const useDigitalCollections = () => {
    const { featureFlags } = useContext(MainContext);
    const [apiMachine] = useApiMachine();
    const { accountSummaryQueryResult } = apiMachine.context;
    const { data: accountSummary } = accountSummaryQueryResult;
    const { billing, product } = accountSummary;
    const isCustomerAssistancePlan = featureFlags.isDigitalCollectionsEnabled &&
        isRevolvingCreditProduct(product.type) &&
        (billing === null || billing === void 0 ? void 0 : billing.customerAssistancePlan);
    const isSettlement = isDCHSettlementEnrolled(billing, product.type, featureFlags);
    return {
        isCustomerAssistancePlan,
        isSettlement
    };
};
